<template>
  <div class="modal fade"
    id="user-data-modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="user-data-label"
    aria-hidden="true"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Dados do usuário</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Fechar">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="modal-body row">
          <div class="col-12">
            <label><small>Nome Completo</small></label>
            <input
              v-model="form.name"
              class="form-control"
              type="text"
              :class="{ 'is-invalid': form.errors.has('name') || !form.name }"
              name="name"
            />
            <has-error :form="form" field="name"></has-error>
          </div>

          <div class="col-12 col-md-7">
            <label><small>Email</small></label>
            <input
              v-model="form.email"
              class="form-control"
              type="email"
              :class="{ 'is-invalid': form.errors.has('email') || !form.email }"
              name="email"
            />
            <div v-if="form.errors.has('email') && form.errors.get('email').includes('já está sendo usado')" class="text-danger">
              <small>
                Já existe um cadastro com este e-mail.
                <b><a class="text-danger" href="#" @click.prevent="changeLogin">Clique aqui para entrar.</a></b>
              </small>
            </div>
            <has-error v-else :form="form" field="email"></has-error>
          </div>


          <div class="col-12 col-md-5">
            <label><small>Telefone</small></label>
            <input
              v-model="form.phone"
              class="form-control"
              type="text"
              :class="{ 'is-invalid': form.errors.has('phone') || !form.phone }"
              name="phone"
            />
            <has-error :form="form" field="phone"></has-error>
          </div>

          <div class="col-12">
            <label>Profissão</label>
            <select
              v-model="form.profession"
              class="form-control"
              :class="{ 'is-invalid': form.errors.has('profession') || !form.profession }"
              name="profession"
            >
              <option value="Médico">Médico</option>
              <option value="Dentista">Dentista</option>
              <option value="Farmacêutico">Farmacêutico</option>
              <option value="Fisioterapeuta Dermato Funcional">Fisioterapeuta Dermato Funcional</option>
              <option value="Enfermeiro Esteta">Enfermeiro Esteta</option>
              <option value="Biomédico">Biomédico</option>
              <option value="Esteticista/Cosmetólogo">Esteticista/Cosmetólogo</option>
              <option value="Estudante da área de saúde estética">Estudante da área de saúde estética</option>
              <option value="Outro">Outro</option>
            </select>
            <has-error :form="form" field="profession"></has-error>
          </div>

          <div class="col-12 col-md-7">
            <label><small>Informe o seu CPF ou CNPJ</small></label>
            <input
              type="tel"
              v-model="form.document"
              v-mask="['###.###.###-##', '##.###.###/####-##']"
              class="form-control"
              :class="{ 'is-invalid': form.errors.has('document') || !form.document }"
              name="document"
            />
            <div v-if="form.errors.has('document')" class="text-danger">
              <small>
                Já existe um cadastro com este CPF/CNPJ.
                <b><a class="text-danger" href="#" @click.prevent="changeLogin">Clique aqui para entrar.</a></b>
              </small>
            </div>
            <has-error v-else :form="form" field="document"></has-error>
          </div>

          <div class="col-12 col-md-5">
            <label><small>Data de Nascimento</small></label>
            <input
              type="date"
              v-model="form.birth_date"
              class="form-control"
              :class="{ 'is-invalid': form.errors.has('birth_date') || !form.birth_date }"
              name="birth_date"
            />
            <has-error :form="form" field="birth_date"></has-error>
          </div>

          <div class="col-12">
            <div class="col-12 col-md-4 p-0">
              <label><small>CEP</small></label>
              <input
                type="tel"
                v-model="form.zip_code"
                v-mask="'########'"
                class="form-control"
                :class="{ 'is-invalid': form.errors.has('zip_code') || !form.zip_code }"
                name="zip_code"
                @change="getCepWebData"
              />
              <has-error :form="form" field="zip_code"></has-error>
            </div>
          </div>

          <div class="col-12 col-md-7">
            <label><small>Endereço</small></label>
            <input
              v-model="form.address"
              class="form-control"
              type="text"
              :class="{ 'is-invalid': form.errors.has('address') || !form.address }"
              name="address"
            />
            <has-error :form="form" field="address"></has-error>
          </div>

          <div class="col-12 col-md-5">
            <label><small>Número</small></label>
            <input
              v-model="form.number"
              class="form-control"
              type="text"
              :class="{ 'is-invalid': form.errors.has('number') || !form.number }"
              name="number"
            />
            <has-error :form="form" field="number"></has-error>
          </div>

          <div class="col-12 col-md-7">
            <label><small>Complemento</small></label>
            <input
              v-model="form.complement"
              class="form-control"
              type="text"
              :class="{ 'is-invalid': form.errors.has('complement') }"
              name="complement"
            />
            <has-error :form="form" field="complement"></has-error>
          </div>

          <div class="col-12 col-md-5">
            <label><small>Bairro</small></label>
            <input
              v-model="form.district"
              class="form-control"
              type="text"
              :class="{ 'is-invalid': form.errors.has('district') || !form.district }"
              name="district"
            />
            <has-error :form="form" field="district"></has-error>
          </div>

          <div class="col-12 col-md-8">
            <label><small>Cidade</small></label>
            <input
              v-model="form.city"
              class="form-control"
              type="text"
              :class="{ 'is-invalid': form.errors.has('city') || !form.city }"
              name="city"
            />
            <has-error :form="form" field="city"></has-error>
          </div>

          <div class="col-12 col-md-4">
            <label><small>UF</small></label>
            <input
              v-model="form.state"
              class="form-control"
              type="text"
              :class="{ 'is-invalid': form.errors.has('state') || !form.state }"
              name="uf"
            />
            <has-error :form="form" field="state"></has-error>
          </div>

          <div class="col-12">
            <label><small>Biografia</small></label>
            <textarea
              v-model="form.bio"
              class="form-control"
              :class="{ 'is-invalid': form.errors.has('bio') }"
            /></textarea>
            <has-error :form="form" field="bio"></has-error>
          </div>

          <div class="col-12">
            <label><small>Nova Senha</small></label>
            <div class="input-group">
              <input
                autocomplete="off"
                v-model="passwd"
                class="form-control"
                :type="pass_type"
                :class="{ 'is-invalid': form.errors.has('password') }"
              />
              <div class="input-group-append bg-white">
                <button
                  class="btn btn-outline-secondary"
                  type="button"
                  @mousedown="showPassWord"
                  @mouseup="hidePassWord"
                >
                  <i class="fas fa-eye"></i>
                </button>
              </div>
            </div>
            <has-error :form="form" field="password"></has-error>
          </div>

          <div class="col-12">
            <label><small>Foto do Perfil</small></label>

            <div class="custom-file">
              <input
                type="file"
                :class="{ 'custom-file-input': true, 'is-invalid': form.errors.has('picture') }"
                id="picture"
                accept="image/png, image/jpeg"
                @change="loadPicture($event)"
              />
              <label class="custom-file-label" for="customFileLang">{{ filename }}</label>
            </div>
            <has-error :form="form" field="picture"></has-error>
          </div>

          <div class="col-12 mb-0">
            <div class="preview-interface rounded d-flex justify-content-center border border-dark" v-if="filePreview">
              <img class="preview" height="150" :src="filePreview">
            </div>
            <button v-if="this.form.id && this.file" class="btn btn-sm btn-success w-100" @click="uploadFile">Salvar Imagem</button>
          </div>

          <div class="col-12">
            <div class="progress my-2" v-if="uploading">
              <div
                class="progress-bar"
                role="progressbar"
                :style="`width: ${ progress }%;`"
                :aria-valuenow="progress"
                aria-valuemin="0"
                aria-valuemax="100"
              >{{ progress }}%</div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-danger" data-dismiss="modal">Cancelar</button>
          <button type="button" class="btn btn-primary" @click="saveData" :disabled="saving">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="saving"></span>
            Salvar Usuários
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from 'axios'
import { Form, HasError } from 'vform'
import { mapGetters } from 'vuex'
import hash from 'hash.js'
import {mask} from 'vue-the-mask'

export default {
  directives: {
    mask
  },
  data () {
    return {
      saving: false,
      passwd: undefined,
      filename: "Procurar Arquivo",
      file: undefined,
      filePreview: undefined,
      progress: 0,
      uploading: false,

      searchingCepStatus: undefined,
      pass_type: "password",

      form: new Form({
        id: undefined,
        name: undefined,
        email: undefined,
        document: undefined,
        profession: undefined,
        phone: undefined,
        picture: undefined,
        birth_date: undefined,
        address: undefined,
        number: undefined,
        complement: undefined,
        district: undefined,
        state: undefined,
        city: undefined,
        country: 'BRA',
        zip_code: undefined,
        bio: undefined,
        is_actived: true,
        // read_confirmation: false;
      })
    }
  },
  computed: {
    ...mapGetters({
      user: 'getCurrentUser'
    })
  },
  methods: {
    loadPicture: function (event) {
      var input = event.target;
      if (input.files && input.files[0]) {
        this.file = input.files[0];
        var reader = new FileReader();
        reader.onload = (e) => {
            this.filePreview = e.target.result;
        }
        reader.readAsDataURL(input.files[0]);
      }
    },

    uploadFile: function () {
      this.uploading = true

      var bodyFormData = new FormData();
      bodyFormData.set('user_id', this.form.id)
      bodyFormData.append('file', this.file)

      Axios.post(`/register/user/upload`,
        bodyFormData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          onUploadProgress: progress => {
            this.progress = ((progress.loaded * 100) / progress.total).toFixed(0)
          }
        }
      )
        .then( res => {
          this.form.picture = res.data.name
        })
        .catch( err => console.error(err))
    },

    showPassWord: function () {
      this.pass_type = "text"
    },

    hidePassWord: function () {
      this.pass_type = "password"
    },

    loadDataUser: function () {
      Axios.get(`/user/info/${ this.user.id }`)
        .then( res => {
          this.form.fill( res.data.data )
        })
    },

    saveData: function () {
      this.saving = true
      if ( this.passwd != '' && this.passwd != undefined ) {
        this.form.password = hash.sha256().update(this.passwd).digest('hex')
      }

      this.form.post('/save/user')
        .then( res => {
          this.$store.commit('SET_CURRENT_USER', res.data.data)
          $('#user-data-modal').modal('hide')
          this.saving = false
        })
        .catch( err => {
          this.saving = false
          console.error( err )
        })
    },

    getCepWebData: function () {
      this.searchingCepStatus = "W"
      Axios.get(`https://cors-anywhere.herokuapp.com/https://viacep.com.br/ws/${ this.form.zip_code }/json/`)
        .then( res => {
          this.$set(this.form, "address", res.data.logradouro)
          this.form.number = res.data.numero
          this.form.complement = res.data.complemento
          this.form.district = res.data.bairro
          this.form.city = res.data.localidade
          this.form.state = res.data.uf
          this.form.country = 'BRA'
          this.searchingCepStatus = "F"
        })
        .catch( err => {
          console.error( err )
          this.searchingCepStatus = ""
        })
        .then( () => {
          if ( !this.form.address ) this.searchingCepStatus = "E"
        })
    },
    changeLogin: function () {
      this.$emit('changeLogin')
    },
  },
  mounted () {
    $("#user-data-modal").on('show.bs.modal', () => this.loadDataUser())
  }
}
</script>

<style>

</style>
